import React from 'react'

import CustomerLanding from './CustomerLanding'
import CustomerLogout from './CustomerLogout'
import CustomerAccountInfo from './CustomerAccountInfo'
import CustomerOrders from './orders/CustomerOrders'
import CustomerPasswordChange from './CustomerPasswordChange'

export default [
	{
		path: "/customer",
		exact: true,
		render: (props) => (<CustomerLanding {...props} />)
	},
	{
		path: "/customer/logout",
		component: CustomerLogout
	},
	{
		path: "/customer/account-info",
		component: CustomerAccountInfo
	},
	{
		path: "/customer/orders",
		component: CustomerOrders
	},
	{
		path: "/customer/change-password",
		component: CustomerPasswordChange
	},
	{
		component: () => <h1 className="no-margin">Page not found</h1>
	}
]



// WEBPACK FOOTER //
// ./src/components/customer/customerRoutes.js